import { render, staticRenderFns } from "./BlockType2Grid.vue?vue&type=template&id=56a6b14b&scoped=true&"
import script from "./BlockType2Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType2Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType2Grid.vue?vue&type=style&index=0&id=56a6b14b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6b14b",
  null
  
)

export default component.exports